import { useState, useEffect } from "react";
import "../../../App.css";
import Listdelete from "./ListDelete";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import Add from "./Add";
const baseURL = process.env.REACT_APP_API_JOBS;
function Members() {
  const [counter, setCounter] = useState(0);
  const [nazeegTypeOptions, setNazeegTypeOptions] = useState([]);
  const [megdarOptions, setMegdarOptions] = useState({});
  const axiosPrivate = useAxiosPrivate();

  const increment = () => {
    setCounter(counter + 1);
  };
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getNazeegTypeOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "nazeegtype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setNazeegTypeOptions(response.data);
        }
      } catch (err) {
        if (err.response) {
          alert("טבלת סוגי הנציג", HandleHttpErrors(err.response.status));
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    const getMegdarOptions = async () => {
      try {
        const response = await axiosPrivate.get(baseURL + "megdartype/", {
          signal: controller.signal,
        });
        if (isMounted) {
          setMegdarOptions(response.data[0].megdarOptions);
        }
      } catch (err) {
        if (err.response) {
          alert("טבלת סוגבי הנציג", HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getNazeegTypeOptions();
    getMegdarOptions();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, []);

  return (
    <div className="App">
      <Add
        increment={increment}
        counter={counter}
        nazeegTypeOptions={nazeegTypeOptions}
      />

      <Listdelete
        increment={increment}
        counter={counter}
        setCounter={setCounter}
        nazeegTypeOptions={nazeegTypeOptions}
        megdarOptions={megdarOptions}
      />
    </div>
  );
}
export default Members;
